module.exports = __webpack_public_path__ + "assets/urendeclareren1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/urendeclareren1.jpg
// module id = 366
// module chunks = 0